import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import {
  coerceBoolean,
  coerceLiteralNumberRequired,
  FIRST_VERSION_TIMESTAMP,
  zodNativeEnum,
  zodNativeEnumOptional
} from '~/lib/zod';
import z from 'zod';

export enum McmVideoType {
  HIGHLIGHT = 'highlight',
  PREMIUM = 'premium',
  LUXURY = 'luxury',
}

export enum McmVideoOrientation {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export enum McmVideoDuration {
  AUDIO15 = 'audio15',
  AUDIO30 = 'audio30',
  AUDIO60 = 'audio60',
  AUDIO90 = 'audio90',
  AUDIO180 = 'audio180',
  NOAUDIO15 = 'noaudio15',
}

export enum McmVideoAgent {
  STORY = 'story',
  INTRO = 'intro',
}

export default createPerformableConfig(
  'video',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      type: z.nativeEnum(McmVideoType),
      agent: z.nativeEnum(McmVideoAgent).optional(),
      orientation: zodNativeEnumOptional(McmVideoOrientation),
      extra: z
        .object({
          orientation: zodNativeEnum(McmVideoOrientation),
          duration: zodNativeEnum(McmVideoDuration),
        })
        .array()
        .optional(),
      social_edit: coerceBoolean().optional(),
      day_to_night: coerceBoolean().optional(),
    }),
  },
  {
    name: 'Video Services',
    short: '',
    package: 'Video',
    tenant: TenantId.MOTION_CITY_MEDIA,
    thumbnail: '',
    images: [],
  },
);
